export let colors = {
  arsenic: ['#f1f6e0', '#cdedA9', '#d6c6da', '#ab7fb4', '#493066'],
  lead: ['#e3eef8', '#b4cfe3', '#f0e58e', '#d2c331', '#6d5e1f'],
  mercury: ['#f7f1cc', '#eedea3', '#c2dfe4', '#4194a3', '#065360'],
};
